module.exports = __webpack_public_path__ + "img/gb848.prt.c4e86f05.jpg";